import { mapEnumToOptions } from '@abp/ng.core';

export enum PrescriptionOrderDeliveryType {
  None = 'None',
  Collect = 'Collect',
  Deliver = 'Deliver',
}

export const prescriptionOrderDeliveryTypeOptions = mapEnumToOptions(PrescriptionOrderDeliveryType);
